exports.headers = [
    // {
    //     text: '模 型',
    //     value: 'model_image',
    //     align: 'center',
    //     sortable: false,
    //     class: 'text-secondary font-weight-bolder opacity-7',
    // },
    {
        text: '任务名称',
        value: 'taskName',
        align: 'center',
        sortable: false,
        class: 'text-secondary font-weight-bolder opacity-7',
    },
    {
        text: '模型需求量',
        value: 'modelNum',
        align: 'center',
        sortable: false,
        class: 'text-secondary font-weight-bolder opacity-7',
    },
    // {
    //     text: '元件类型',
    //     value: 'model_category',
    //     align: 'center',
    //     sortable: false,
    //     class: 'text-secondary font-weight-bolder opacity-7',
    // },
    // {
    //     text: '状 态',
    //     value: 'status',
    //     align: 'center',
    //     sortable: false,
    //     width: 150,
    //     class: 'text-secondary font-weight-bolder opacity-7',
    // },
    {
        text: '申请日期',
        value: 'updated_at',
        sortable: false,
        align: 'center',
        class: 'text-secondary font-weight-bolder opacity-7',
    },
    {
        text: '操作',
        value: 'actions',
        align: 'center',
        sortable: false,
        class: 'text-secondary font-weight-bolder opacity-7',
    },
]